export const ApplicationStatus = {
    CREATED: 0,
    STALE: 10,
    ADMITTED: 20,
    INPROGRESS: 30,
    NEEDINFO: 40,
    REJECTED: 50,
    GRANTED: 60,
    DONE: 70,
    UNKNOWN: 1000
}

export const ProcurementType = {
    COST: 0,
    HOUR: 10
}

export const ApplicationChoiceType = {
    PURPOSE: 0,
    AREA: 10,
    AGEGROUP: 100
}

export const Role = {
    USER: 0,
    MAINUSER: 10,
    REVISOR: 100,
    SUPERUSER: 1000,
    SYSTEM: 10000
}

export const EmailType = {
    USERNEW: 0,
    USERPASSWORDCHANGED: 1,
    APPLICATIONADMITTED: 9,
    APPLICATIONGRANTED: 10,
    APPLICATIONMOREINFO: 20,
    APPLICATIONREJECTED: 30,
    COMPANYNEW: 40,
    COMPANYNEWUSER: 50,
}

export let applicationChoiceTemplateTypeText = (type) => {
    switch (type) {
        default:
        case ApplicationChoiceType.PURPOSE: {
            return "Formålskategori";
        }
        case ApplicationChoiceType.AREA: {
            return "Formålsområde";
        }
        case ApplicationChoiceType.AGEGROUP: {
            return "Aldersgruppe";
        }
    }
}

export let emailTypeText = (emailType) => {
    switch (emailType) {
        case EmailType.USERNEW: {
            return "Bruker: ny";
        }
        case EmailType.USERPASSWORDCHANGED: {
            return "Bruker: endret passord";
        }
        case EmailType.APPLICATIONADMITTED: {
            return "Søknad: Levert";
        }
        case EmailType.APPLICATIONGRANTED: {
            return "Søknad: innvilget";
        }
        case EmailType.APPLICATIONMOREINFO: {
            return "Søknad: trenger tilleggsinformasjon";
        }
        case EmailType.APPLICATIONREJECTED: {
            return "Søknad: avslått";
        }
        case EmailType.COMPANYNEW: {
            return "Selskap: ny";
        }
        case EmailType.COMPANYNEWUSER: {
            return "Selskap: ny bruker";
        }
        default:
            break;
    }
}

export let applicationStatusText = (status) => {
    if (typeof status === "object") {
        if ("type" in status) {
            status = status.type;
        }
        else {
            throw new Error("Status object malformed.");
        }
    }

    switch (status) {
        default:
        case ApplicationStatus.CREATED: {
            return "Opprettet";
        }
        case ApplicationStatus.STALE: {
            return "Foreldet";
        }
        case ApplicationStatus.ADMITTED: {
            return "Levert";
        }
        case ApplicationStatus.INPROGRESS: {
            return "Under behandling";
        }
        case ApplicationStatus.NEEDINFO: {
            return "Trenger tilleggsinformasjon";
        }
        case ApplicationStatus.REJECTED: {
            return "Avslått";
        }
        case ApplicationStatus.GRANTED: {
            return "Innvilget";
        }
        case ApplicationStatus.DONE: {
            return "Ferdig";
        }
        case ApplicationStatus.UNKNOWN: {
            return "Ukjent";
        }
    }
}

export let applicationStatusIcon = (status) => {
    switch (status) {
        default:
        case ApplicationStatus.CREATED: {
            return "mdi-pencil-circle";
        }
        case ApplicationStatus.STALE: {
            return "mdi-timer-outline";
        }
        case ApplicationStatus.ADMITTED: {
            return "mdi-send";
        }
        case ApplicationStatus.INPROGRESS: {
            return "mdi-magnify";
        }
        case ApplicationStatus.NEEDINFO: {
            return "mdi-information";
        }
        case ApplicationStatus.REJECTED: {
            return "mdi-close-circle";
        }
        case ApplicationStatus.GRANTED: {
            return "mdi-check-circle";
        }
        case ApplicationStatus.DONE: {
            return "mdi-stop";
        }
        case ApplicationStatus.UNKNOWN: {
            return "mdi-help-circle";
        }
    }
}